import {
    ENTITY_PART_TYPE_KNOWN,
    ENTITY_PART_TYPE_CUSTOM,
    ENTITY_PART_TYPE_COUNTRY,
    ENTITY_PART_TYPE_SEPARATOR,
    ENTITY_PART_TYPE_PLACEHOLDER,
    SEPARATOR_PLUS,
    SEPARATOR_FORWARD_SLASH,
    SEPARATOR_PLUS_FORWARD_SLASH,
} from './common/EntityPart';

export const LOCATIONS_ENTITY_SEPARATOR_CHARACTERS = [
    SEPARATOR_FORWARD_SLASH,
    SEPARATOR_PLUS,
    SEPARATOR_PLUS_FORWARD_SLASH,
];

export const STS_PREFIX = 'STS ';

export const createKnownLocationPart = (location) =>
    createPart(
        location.id,
        location.name,
        ENTITY_PART_TYPE_KNOWN,
        location.deskArea,
        location.deskAreaGeared,
        location.deskZone,
        location.globalZone,
        location.isSTS,
        location.eastWest,
        location.displayName
    );

export const createCountryLocationPart = (location) =>
    createPart(
        location.id,
        location.name,
        ENTITY_PART_TYPE_COUNTRY,
        location.deskArea,
        location.deskAreaGeared,
        location.deskZone,
        null,
        false,
        location.eastWest,
        location.displayName
    );

export const createCustomLocationPart = (location) =>
    createPart(
        location.name,
        null,
        ENTITY_PART_TYPE_CUSTOM,
        null,
        null,
        null,
        null,
        false,
        location.eastWest,
        location.displayName
    );

export const createPlaceholderLocationPart = (character) =>
    createPart(
        character,
        null,
        ENTITY_PART_TYPE_PLACEHOLDER,
        null,
        null,
        null,
        null,
        false,
        null,
        null
    );

export const createSeparatorLocationPart = (character) =>
    createPart(
        character,
        null,
        ENTITY_PART_TYPE_SEPARATOR,
        null,
        null,
        null,
        null,
        false,
        null,
        null
    );

const createPart = (
    value,
    name,
    partType,
    deskArea,
    deskAreaGeared,
    deskZone,
    globalZone,
    isSTS,
    eastWest,
    displayName
) => {
    return {
        displayName,
        value,
        name,
        partType,
        deskArea,
        deskAreaGeared,
        deskZone,
        globalZone,
        isSTS,
        eastWest,
    };
};

export const isRangesLocation = (locationType) => {
    return locationType === 'Ranges';
};

export const isWorldwideZoneLocation = (locationType) => {
    return locationType === 'WorldwideZone';
};
